export function displayChecks() {
    const div = document.createElement("div");
    const iframe = document.createElement("iframe");
    const checksContainerRef = document.getElementById("checksContainer");

    if (!checksContainerRef) {
        iframe.setAttribute("src", "https://checks.upshow.tv/");
        iframe.setAttribute("id", "checksIframe");
        div.append(iframe);
        div.setAttribute("id", "checksContainer");
        document.body.appendChild(div);

        setTimeout(() => {
            const checksContainerRef = document.getElementById("checksContainer");
            if (checksContainerRef) checksContainerRef.remove();
        }, 20000);
    }
}

export function setupAndroidSkykitChecks(model) {
    setTimeout(() => {
        const checksButtonRef = document.getElementById("checks-button");
        if (["AndroidSkykit", "Skykit"].includes(model) && checksButtonRef) {
            checksButtonRef.onclick = displayChecks;
            checksButtonRef.classList.remove("hidden");
        }
    }, 30);
}

export function notifyAndroidAppStarted() {
    // Report to android app that the UI has started
    if (window.UPshowAndroidApp && window.UPshowAndroidApp.uiStarted) {
        window.UPshowAndroidApp.uiStarted();
    }
}
